import { useUIStore } from '@/store/uiStore';

export function LoadingOverlay() {
  const loading = useUIStore((s) => s.globalLoading);
  const text = useUIStore((s) => s.globalLoadingText);
  if (!loading) return null;
  return (
    <div className="fixed inset-0 z-[100] bg-black/70 backdrop-blur-sm flex flex-col items-center justify-center gap-4 animate-fade-in">
      <div className="w-12 h-12 rounded-full border-4 border-white/10 border-t-accent animate-spin" />
      {text && <div className="text-white/80 text-sm">{text}</div>}
    </div>
  );
}
